var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true
    }
  }, [_vm.isError ? _c('v-container', [_c('v-card', {
    staticClass: "ma-auto",
    staticStyle: {
      "max-width": "650px"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-banner', {
    staticClass: "mr-auto ml-auto",
    attrs: {
      "align": "center"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "250"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "src": require("@/assets/undraw/undraw_authentication_fsn5.svg")
    }
  })], 1)], 1)], 1), _c('v-card-text', [_c('p', {
    staticClass: "text",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(" Fehlende Berechtigung zu dieser Seite. "), _c('br'), _vm._v(" Bitte mit geeigneten Zugriffsrechten anmelden. ")])])], 1)], 1) : _vm.fleetId ? _c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-header', {
    staticClass: "ml-n4",
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.description,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      }
    }
  })], 1), _c('fleet-manager-tree-dialog', {
    ref: "dialog",
    on: {
      "confirm": _vm.load
    }
  })], 1), _vm._l(_vm.navItems, function (nav, i) {
    return _c('v-row', {
      key: i,
      staticClass: "pb-8",
      attrs: {
        "dense": ""
      }
    }, [nav.isEnabled ? [_c('v-col', {
      staticClass: "pb-4",
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "mb-0 h3"
    }, [_vm._v(_vm._s(_vm.$t(nav.title)))]), _c('v-divider')], 1), _vm._l(nav.items, function (item, j) {
      return _c('v-col', {
        key: j,
        attrs: {
          "cols": "6",
          "md": "4"
        }
      }, [item.isEnabled ? _c('v-card', {
        on: {
          "click": item.click
        }
      }, [_c('v-img', {
        staticClass: "white--text align-end",
        attrs: {
          "height": "150px",
          "gradient": "to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)",
          "src": item.src
        }
      }, [_c('v-card-subtitle', [_vm._v(_vm._s(_vm.$t(item.title)))])], 1)], 1) : _vm._e()], 1);
    })] : _vm._e()], 2);
  })], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }